import Logo from './Logo.vue';

export { Logo };
export default Logo;
